import { createContext, ReactElement, useCallback, useContext, useState } from 'react';
import { DrawerStateType } from './types';

interface DrawerProviderProps {
  children: React.ReactNode;
}

const DrawerContext = createContext<DrawerStateType | undefined>(undefined);

export const DrawerProvider = ({ children }: DrawerProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ReactElement | null>(null);

  const open = (contentToShow: ReactElement) => {
    setContent(contentToShow);
    setIsOpen(true);
  };

  const close = useCallback(() => {
    setIsOpen(false);
    setContent(null);
  }, []);

  return <DrawerContext.Provider value={{ isOpen, open, close, content }}>{children}</DrawerContext.Provider>;
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};
